var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7791 18.5396C31.0479 19.05 31.8354 20.5521 31.5437 21.8792L30.9458 24.5917C29.9104 29.2584 26.25 32.5834 20.9708 32.5834H14.0291C8.74994 32.5834 5.08953 29.2584 4.05412 24.5917L3.4562 21.8792C3.16453 20.5521 3.95202 19.05 5.22077 18.5396L7.29162 17.7084L15.327 14.4854C16.727 13.9313 18.2729 13.9313 19.6729 14.4854L27.7083 17.7084L29.7791 18.5396Z",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 32.5833V15.0833",
    stroke: "#1B9CF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 12.1667V17.7084L19.6729 14.4855C18.2729 13.9313 16.7271 13.9313 15.3271 14.4855L7.29163 17.7084V12.1667C7.29163 9.7605 9.26038 7.79175 11.6666 7.79175H23.3333C25.7395 7.79175 27.7083 9.7605 27.7083 12.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1458 7.79175H13.8541V4.87508C13.8541 4.073 14.5104 3.41675 15.3125 3.41675H19.6875C20.4895 3.41675 21.1458 4.073 21.1458 4.87508V7.79175Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.280ce4c5666f157d12dc27bcc0cab900.svg";
export { ForwardRef as ReactComponent };